import store from "@/store";
import makePermission from "@/permissions/makePermission";
import { Route } from "vue-router";

export default makePermission((): {
    redirectRouteName: string;
    hasPermission: (to: Route) => Promise<boolean>;
    query?: Object;
} => ({
    redirectRouteName: "login",
    async hasPermission(to: Route) {
        await store.dispatch("auth/init");
        const isAuthenticated = store.getters["auth/isAuthenticated"];
        if (!isAuthenticated) {
            this.query = {
                next: to.fullPath
            };
        }
        return isAuthenticated;
    }
}));
